function SearchParentsFor(start, cls, top) {
    var result;

    var parent = start.parentNode;
    if ((parent) && (parent.getAttribute)) {
        var pcls = parent.getAttribute("class");
        if (pcls) {
            var pclsArray = pcls.split(" ");
            for (var i = 0; i < pclsArray.length; i++) {
                if (pclsArray[i] == cls) {
                    result = parent;
                    break;
                }
            }
        }

        if ((!result) && ((!top) || (parent != top))) {
            result = SearchParentsFor(parent, cls, top);
        }
    }

    return (result);
}

function AddClass(el, cls) {
    if (el) {
        var current = el.getAttribute("class");
        if ((current == undefined) || (current.indexOf(cls) == -1)) {
            current += " " + cls;
            el.setAttribute("class", current);
        }
    }
}
function RemoveClass(el, cls) {
    if (el) {
        var current = el.getAttribute("class");
        if (current) {
            current = current.replace(cls, ' ');
            el.setAttribute("class", current);
        }
    }
}

function HasClass(el, cls) {
    var current = el.getAttribute("class");
    return ((current != undefined) && (current.indexOf(cls) != -1));
}

function ShowCartEditSection(element, extend) 
{
    var parent = SearchParentsFor(element, "cart--item");
    var container = parent.querySelector(".hide_cart-editable-section");
    var inner = container.querySelector(".hide_cart-editable-section-inner");

    // console.log(inner.offsetHeight);
    if (container.offsetHeight == 0 || extend ) 
    {
        container.style.height = inner.offsetHeight + "px";
    }
    else 
    {
        container.style.height = 0 + "px";
    }


}

function getChosenVariant(element) {
    var options = element.querySelectorAll("option");

    for (var i = 0; i < options.length; i++) {
        var option = options[i];
        var selected = element.selectedIndex;

        if (i == selected) {
            element.dataset.option = option.value;
        }
    }
}

function updateChosenVariant(element) {
    
    var options     = [];
    var item        = SearchParentsFor( element, "cart--item" );
    var selects     = item.querySelectorAll( ".lightning-add-to-cart-collection select" );
    var canProceed  = true; 

    for( var i = 0; i < selects.length; i++ )
    {
        var select = selects[ i ];

        if( !select.value.includes( "Change" ) )
        {
            var optionObj = {};
            optionObj[ "option" + ( i + 1 ) ] = select.value
            options.push( optionObj );
        }
        else
        {
            canProceed = false;

            //show msg
            var p       = document.createElement( "p" );
            p.innerText = "Please Choose";
            p.style.fontSize = "14px";
            select.parentNode.insertBefore( p, select.nextSibling);
            select.style.margin = "0px";

            //extend the height 
            ShowCartEditSection( item.querySelector( ".edit_cart-container p" ) , true);
            break;
        }
    }

    if( canProceed )
    {
        var productVariants = item.querySelectorAll( ".collection-product-select-hidden option" );

        var value;
        for( var i = 0; i < productVariants.length; i++ )
        {
            var variant = productVariants[ i ];
            var isTheSame = true;

            for( var j = 0; j < options.length; j++ )
            {
                var option = options[ j ];
                if( variant.dataset[ "option" + ( j + 1 ) ] != option[ "option" + ( j + 1 ) ] )
                {
                    var isTheSame = false;
                }
            }

            if( isTheSame )
            {
                value = variant.value;
            }
        }

        if( value ) 
        {
            UpdateProduct( item, value )
        }

    }

    
    // var option1;
    // var option2;
    // var option3;
    // var value;

    // var selectContainers = document.querySelectorAll(".cart--item");

    // for (var i = 0; i < selectContainers.length; i++) {
    //     var selectContainer = selectContainers[i];
    //     var selects = selectContainer.querySelectorAll("select");

    //     for (var j = 0; j < selects.length; j++) {
    //         var select = selects[j];
    //         var option = select.dataset.option;
    //         if (option) {
    //             console.log(option);
    //             if (j == 0) {
    //                 option1 = option;
    //             }
    //             if (j == 1) {
    //                 option2 = option;
    //             }
    //             if (j == 2) {
    //                 option3 = option;
    //             }

    //             var selectedVariant;
    //             if (option1 && option2 && option3) {
    //                 var selectedVariant = option1 + " / " + option2 + " / " + option3;
    //             }
    //             else if ((option1 && option2) && (option3 == undefined)) {
    //                 var selectedVariant = option1 + " / " + option2;
    //             }
    //             else if ((option1) && (option2 == undefined && option3 == undefined)) {
    //                 var selectedVariant = option1;
    //             }
    //             console.log(selectedVariant);
    //             var productVariant = selectContainer.querySelector(".collection-product-select-hidden");
    //             var productVariantOptions = productVariant.querySelectorAll("option");
    //             for (var k = 0; k < productVariantOptions.length; k++) {
    //                 var productVariantOption = productVariantOptions[k];
    //                 if (selectedVariant == productVariantOption.innerHTML) {
    //                     value = productVariantOption.value
    //                 }
    //             }
    //         }
    //     }

    //     if (value) {
    //         UpdateProduct(selectContainer, value)
    //     }
    // }
}

function UpdateProduct(element, value) {

    var newVariant = value;
    var lineIdx = Number(element.dataset.line_index);
    var qty = Number(element.dataset.qty);

    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status == 200) {
                AddNewVariant(qty, newVariant);
            }
            else {
                console.log("removing old variant failed" + xhr.responseText);
            }
        }
    };

    xhr.open("POST", "/cart/change.js", true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify({ "quantity": 0, "line": lineIdx }));

}

function AddNewVariant(qty, newVariant) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status == 200) {
                window.location.reload();
            }
            else {
                console.log("add new variant faild" + xhr.responseText);
            }
        }
    };

    xhr.open("POST", "/cart/add.js", true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify({ "quantity": qty, "id": newVariant }));

}

function RemoveItemFromCart( )
{
    event.preventDefault();
    var item = SearchParentsFor( event.currentTarget, "cart--item" );
    for( var i = 0; i < item.querySelectorAll( ".pw-loading-animation-target" ).length; i++ )
    {
        var targ = item.querySelectorAll( ".pw-loading-animation-target" )[ i ];
        targ.classList.remove( "hidden" );
    }
    $.ajax(
    {
        url: event.currentTarget.href, 
        complete: function (res) 
        {
            rebuildCartHTML('desktop');
            rebuildCartHTML('mobile');
        }
    });
}

//console.log( "wtf" );

window.addEventListener("DOMContentLoaded", function (e) 
{
    // console.log( "wtf" );
    $(".off-canvas--right-sidebar .ro_widget").addClass("hidden");

    $(".off-canvas--right-sidebar button.cart--checkout-button").on("click", function (e) {
        var boldIndicators = document.querySelectorAll(".off-canvas--right-sidebar .bold_recurring_desc");
        if (boldIndicators.length == 0) {
            e.preventDefault();
            window.location.href = "/checkout";
        }
    });

    // $( ".pw-cart-drawer-remove" ).on( "click", function( e )
    // {
    //     RemoveItemFromCart( e );
    // } );
});




this.reorder = new function () {
    var self = this;

    this.pushQueue = function (i, data, el) {

        //LOW STOCK -- add as many as possible if stock is below requested ammount
        // if (data[i].check_inventory) {
        //     data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
        // }

        $.ajax({
            url: '/cart/add.js',
            method: 'POST',
            data: {
                quantity: data[i].quantity,
                id: data[i].id,
                properties: {
                    '_productType': 'offer'
                }
            },
            complete: function (res) {
                if (i >= data.length - 1) {
                    // window.location.href = '/cart';

                    rebuildCartHTML('desktop');
                    rebuildCartHTML('mobile');
                    return;
                } else {
                    // Calls are async as required by Shopify Docs
                    self.pushQueue(i + 1, data, el);
                }
            }
        });
    }

    this.listen = function () {
        var el = $(this);
        el.parents('.cart-offers-tiers').addClass('loading');
        var ids = [],
            quantities = [];
        el.parents(".cart-offers-tiers").find('.cart--item:not(.hidden)').each(function (index) {
            ids[index] = $(this).find('*[name="basket-offer-id"]').val();
            quantities[index] = 1;
        });
        var data = [];
        for (var i = 0; i < ids.length; i++) {
            data.push({
                id: ids[i],
                quantity: quantities[i]
            });
        }
        self.pushQueue(0, data, el);
    }

    this.init = function () {
        $('.add_offer_products_to_cart').on('click', self.listen);
    }
}
$(reorder.init);

function getAjaxUrl(viewType) {
    var ajax_url = window.location.href;
    ajax_url = ajax_url.replace(window.location.hostname + window.location.pathname, window.location.hostname + '/cart');
    ajax_url = ajax_url.replace('#', '');
    if (ajax_url.indexOf("?") >= 0) {
        ajax_url = ajax_url + '&';
    } else {
        ajax_url = ajax_url + '?';
    }
    if (viewType == 'mobile') {
        return ajax_url + 'view=ajax--mobile';
    } else {
        return ajax_url + 'view=ajax--desktop';
    }
};


function rebuildCartHTML(viewType) {
    var url = getAjaxUrl(viewType);
    $.ajax({
        url: url,
        method: 'GET',
        dataType: "html",
        success: function (data) {
            var new_html;
            new_html = $($.parseHTML(data));
            var new_form, old_form;
            old_form = $(".cart--root[data-view='" + viewType + "']").find('.cart--form');
            new_form = new_html.find('.cart--form');
            old_form.replaceWith(new_form);
            $(".cart--root[data-view='" + viewType + "']").find('.cart-offers-tiers').removeClass('loading');
            $(".cart--root[data-view='" + viewType + "']").find(".cart-offers-tiers").addClass('hidden');
        }
    });
}
// remove cart item from sidebar using ajax

$(document).on('click', '.removeCartItem', function (e) {
    e.preventDefault();
    var id = $(this).parents('.cart--item').data('variant-id');
    var product_id = $(this).parents('.cart--item').data('product-id');
    $.ajax({
        url: '/cart/change.js',
        method: 'POST',
        dataType: "JSON",
        data: {
            id: id,
            quantity: 0
        },
        success: function (data) {
            // remove HTML from cart
            $('.cart--item[data-variant-id="' + id + '"]').remove();
            var offerProductCountinCart = 0;
            for (let i = 0; i < data.items.length; i++) {
                const element = data.items[i];
                if(!isEmpty(element.properties)) {
                    if(element.properties._productType == "offer" ){
                        offerProductCountinCart = offerProductCountinCart + 1;
                    }
                }
            }
            setTimeout(() => {
                console.log("offer Product Count in Cart: ",offerProductCountinCart);
                            console.log("cart item_count: ",data.item_count);
                if(offerProductCountinCart == data.item_count){
                    $.ajax({
                        type: "POST",
                        url: '/cart/clear.js',
                        data: '',
                        dataType: 'json',
                        success: function(data) { 
                            $('.cart--item').remove();
                            checkBasketOfferThresholds(data);
                        }
                    }); 
                }
                else{
                    checkBasketOfferThresholds(data);
                }
            }, 1000);
        }
    });
});

function RefreshBasketOfferUI( cb )
{
    $.ajax(
    {
        "url"      : '/cart.js',
        "method"   : 'GET',
        "dataType" : "JSON",
        "success"  : function( data )
        {
            checkBasketOfferThresholds( data, cb );
        }
    } );
}

function SetupCartUpdateHandling()
{
    var timer;
    var watch    = document.querySelector(".off-canvas--right-sidebar");
    var observer = new MutationObserver(function (ml, o)
    {
        function DebounceHandler()
        {
            observer.disconnect( );
            observer.takeRecords( );
            RefreshBasketOfferUI( function( )
            {
                observer.observe(watch, { "childList": true, "subtree": true });
            } );
        }

        if ( timer != undefined )
        {
            clearTimeout( timer );
        }
        timer = setTimeout( DebounceHandler, 500 );
    } );

    console.log( "setup cart handling" );
    observer.observe(watch, { "childList": true, "subtree": true });
    
    RefreshBasketOfferUI( );
}

window.addEventListener("load", function ()
{
    SetupCartUpdateHandling();
});
function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

var g_removing = false;
function RemoveOfferProducts( basket )
{
    var offerProducts = document.querySelectorAll( ".basket-offer-item" );
    var param         = { "updates" : { } };
    var counter       = 0;

    for ( var i = 0; i < basket.items.length; i++ )
    {
        var item = basket.items[ i ];
        if ( ( item.properties ) && ( item.properties._productType == "offer" ) )
        {
            var vid = item.variant_id;
            if ( vid )
            {
                param.updates[ vid ] = 0;
                counter++;
            }
        }
    }

    if ( counter > 0 )
    {
        if ( g_removing )
        {
        }
        else
        {
            g_removing = true;
            $.ajax( { "url": "/cart/update.js", "method": "POST", "data" : param, "complete" : function( )
            {
                g_removing = false;
                //RefreshBasketOfferUI( );

                rebuildCartHTML('desktop');
                rebuildCartHTML('mobile');
            } } );
        }
    }
}

function CheckOfferTiers( data, tierThresholds, cb )
{
    $('.cart-offers-tiers').addClass('hidden');
    $('.cart-offers-tiers .cart--item').addClass('hidden');
    var tier_1 = parseInt($(tierThresholds).data('tier-1'));
    var tier_2 = parseInt($(tierThresholds).data('tier-2'));
    var tier_3 = parseInt($(tierThresholds).data('tier-3'));
    var cartTotal = data.total_price;

    var cartIds = '';
    for (let i = 0; i < data.items.length; i++) {
        const element = data.items[i];
        cartIds = cartIds + ',' + element.product_id;
    }

    var subscriptionItems = document.querySelectorAll( ".cart--root .bold_recurring_desc" );

    if ( subscriptionItems.length > 0 )
    {
        $('.cart-offers-tiers').addClass('hidden');
        $('.tier_1_product').addClass('hidden');
        $('.tier_2_product').addClass('hidden');

        RemoveOfferProducts( data );
    }
    else if ( ( cartTotal == 0 ) || ( cartTotal <= tier_1 ) )
    {
        //console.log( "basket value " + cartTotal + " below tier 1 " + tier_1 + ", disabling offers" );
        $('.cart-offers-tiers').addClass('hidden');
        $('.tier_1_product').addClass('hidden');
        $('.tier_2_product').addClass('hidden');
    }
    else
    {
        var productsToOffer = 0;

        if (cartTotal > tier_1)
        {
            //console.log( "basket value " + cartTotal + " above tier 1, showing tier 1 offer products" );
            $('.tier_1_product').each(function (index)
            {
                if (cartIds.includes($(this).data('product-id')) == false)
                {
                    productsToOffer++;
                    $(this).removeClass('hidden');
                }
            });
            $('.tier_2_product').addClass('hidden');
        }
        if (cartTotal > tier_2)
        {
            //console.log( "basket value " + cartTotal + " above tier 2, showing tier 2 offer products" );
            $('.tier_2_product').each(function (index)
            {
                if (cartIds.includes($(this).data('product-id')) == false)
                {
                    productsToOffer++;
                    $(this).removeClass('hidden');
                }
            });
        }
        if (cartTotal > tier_3)
        {
            //console.log( "basket value " + cartTotal + " above tier 3, showing tier 3 offer products" );
            $('.tier_3_product').each(function (index)
            {
                if (cartIds.includes($(this).data('product-id')) == false)
                {
                    productsToOffer++;
                    $(this).removeClass('hidden');
                }
            });
        }
        if ( productsToOffer > 0 )
        {
            $('.cart-offers-tiers').removeClass('hidden');
        }
    }

    if ( cb )
    {
        cb( );
    }
}

function CreateElement( tag, cls )
{
    var result = document.createElement( tag );
    result.setAttribute( "class", cls );
    return ( result );
}
 
var g_products;
var g_pending = [ ];
function GetProduct( id, cb )
{
    if ( g_products == undefined )
    {
        g_pending.push( function( )
        {
            cb( g_products[ id ] );
        } );
        

        if ( g_pending.length == 1 )
        {
            $.ajax(
            {
                "url"      : '/products.json?limit=250',
                "method"   : 'GET',
                "dataType" : "JSON",
                "success"  : function( data )
                {
                    if ( ( data ) && ( data.products ) )
                    {
                        g_products = { };
                        console.log( "got " + data.products.length + " products" );

                        for ( var i = 0; i < data.products.length; i++ )
                        {
                            var product = data.products[ i ];
                            g_products[ product.id ] = product;
                        }

                        for ( var i = 0; i < g_pending.length; i++ )
                        {
                            g_pending[ i ]( );
                        }
                    }
                }
            } );
        }
    }
    else
    {
        cb( g_products[ id ] );
    }
}

function AppendVariantSelector( ui, item, cb )
{
    GetProduct( item.product_id, function( product )
    {
        if ( product )
        {
            if ( product.variants.length == 1 )
            {
                var inp = CreateElement( "input", "hidden" );
                inp.setAttribute( "name", "basket-offer-id" );
                inp.setAttribute( "value", product.variants[ 0 ].id );
                ui.appendChild( inp );
            }
            else
            {
                var sel = CreateElement( "select", "medium" );
                sel.setAttribute( "name", "basket-offer-id" );
                sel.setAttribute( "data-productid", product.id );

                for ( var i = 0; i < product.variants.length; i++ )
                {   
                    var variant = product.variants[ i ];
                    var price   = Math.floor( Number( variant.price ) * 100 );

                    if ( price == item.price )
                    {
                        var opt = document.createElement( "option" );

                        opt.setAttribute( "data-sku", variant.sku );
                        opt.setAttribute( "value", variant.id );

                        if ( !variant.available )
                        {
                            opt.setAttribute( "disabled", "disabled" );
                        }

                        opt.appendChild( document.createTextNode( variant.title ) );
                        sel.appendChild( opt );
                    }
                }
                        
                ui.appendChild( sel );
            }
        }
        cb( );
    } );
}

function CreateOfferItemUI( item, cb )
{
    var wrapper = CreateElement( "div", "cart--item" );
    wrapper.setAttribute( "data-product-id", item.product_id );

    var imgWrapper = CreateElement( "div", "cart--item--image" );
    var link = document.createElement( "a" );
    link.setAttribute( "href", item.url );
    var img = document.createElement( "img" );
    img.setAttribute( "src", item.image );
    link.appendChild( img );
    imgWrapper.appendChild( link );
    wrapper.appendChild( imgWrapper );

    var title   = CreateElement( "div", "cart--item--title" );
    var heading = CreateElement( "div", "font--block-heading" );
    var tlink   = document.createElement( "a" );
    tlink.setAttribute( "href", item.url );
    tlink.appendChild( document.createTextNode( item.title ) );
    heading.appendChild( tlink );
    title.appendChild( heading );

    AppendVariantSelector( title, item, cb );
    
    wrapper.appendChild( title );

    return ( wrapper );
}

function CheckBogof( data, cb )
{
    var bogoffs = document.querySelectorAll( ".basket-offer-bogoff-container" );
    var asyncs  = 1;
    function Done( )
    {
        asyncs--;
        if ( ( asyncs == 0 ) && ( cb ) )
        {
            cb( );
        }
    }

    var counts = { };
    for ( var i = 0; i < data.items.length; i++ )
    {
        var item = data.items[ i ];
        if ( counts[ item.product_id ] == undefined )
        {
            counts[ item.product_id ] = 0;
        }
        counts[ item.product_id ] += item.quantity;
    }

    var active = false;
    
    for ( var j = 0; j < bogoffs.length; j++ )
    {
        var bogoff           = bogoffs[ j ];
        var productContainer = bogoff.querySelector( ".offer-products" );
        var checks           = { };
        
        while ( productContainer.firstChild )
        {
            productContainer.removeChild( productContainer.firstChild );
        }

        for ( var i = 0; i < data.items.length; i++ )
        {
            var item = data.items[ i ];
            if ( ( item.properties ) && ( item.properties.shipping_interval_frequency ) )
            {
                // doesn't apply to Recharge subscriptions
            }
            else if ( ( item.properties ) && ( item.properties.frequency_num ) )
            {
                // doesn't apply to Bold subscriptions
            }
            else if ( checks[ item.product_id ] )
            {
                // already checked for this DOM tree
            }
            else if ( counts[ item.product_id ] % 2 == 1 )
            {
                // only applies to odd numbered quantities
                asyncs++;
                var itemUI = CreateOfferItemUI( item, Done );
                productContainer.appendChild( itemUI );
                active = true;
                checks[ item.product_id ] = true;
            }
        }
    }

    if ( active )
    {
        $( ".basket-offer-bogoff-container" ).removeClass( "hidden" );
    }
    else
    {
        $( ".basket-offer-bogoff-container" ).addClass( "hidden" );
    }
    Done( );
}



function CheckGWPProducts( gwp, data, cb )
{
    var gwp_id     = gwp.getAttribute( "data-gwp-id" );
    var triggers   = gwp.getAttribute( "data-trigger-skus" );
    var qualifying = 0;
    var existing   = 0;
    for ( var i = 0; i < data.items.length; i++ )
    {
        var item = data.items[ i ];
        var sku  = item.sku;

        if ( triggers.indexOf( sku ) >= 0 )
        {
            qualifying += item.quantity;
        }
        else if ( item.product_id == gwp_id )
        {
            existing += item.quantity;
        }
    }

    //console.log( "gwp :  found " + qualifying + " triggers and " + existing + " added products" );
    if ( qualifying > existing )
    {
        $( ".basket-offer-gwp-container" ).removeClass( "hidden" );
    }
    else
    {
        $( ".basket-offer-gwp-container" ).addClass( "hidden" );
    }
}


function checkBasketOfferThresholds( data, cb )
{
    var tierThresholds = document.querySelector( ".basket-offer-tier-thresholds" );
    var bogoff         = document.querySelector( ".basket-offer-bogoff-container" );
    var gwp            = document.querySelector( ".basket-offer-gwp-container" );

    if ( bogoff )
    {
        CheckBogof( data, cb );
    }
    else if ( tierThresholds )
    {
        CheckOfferTiers( data, tierThresholds, cb );
    }
    else if ( gwp )
    {
        CheckGWPProducts( gwp, data, cb );
    }
}

function BasketOfferVariantSelect( sel )
{
    var item    = $( sel ).closest( ".basket-offer-item" )[ 0 ];
    var selects = item.querySelectorAll( ".basket-offer-option" );
    var options = [ "", "", "", "" ];

    for ( var i = 0; i < selects.length; i++ )
    {
        var select = selects[ i ];
        var option = Number( select.getAttribute( "data-option" ) );
        var value  = select.options[ select.selectedIndex ].value;

        options[ option ] = value;
    }

    var selector = item.querySelector( ".basket-offer-variant-selector" );
    for ( var i = 1; i < selector.options.length; i++ )
    {
        var option  = selector.options[ i ];
        var option1 = option.getAttribute( "data-option1" );
        var option2 = option.getAttribute( "data-option2" );
        var option3 = option.getAttribute( "data-option3" );

        if ( ( option1 == options[ 1 ] ) && ( option2 == options[ 2 ] ) && ( option3 == options[ 3 ] ) )
        {
            selector.selectedIndex = i;
            break;
        }
    }
}


// remove cart item ajax

//jQuery(document).ready(function($){
  var itemsArray1 = [];
  $(document).on('click','.build_a_box_remove_cart_ajax',function(e){
    //setTimeout(function(){
      $(".buil_a_box_cart").each(function(){
        var id = $(this).attr("data-variant-id");
        itemsArray1.push(id);
      });
      //console.log(itemsArray1);
      var qty = 0;
      var data = { updates: {} };
      for (var i = 0; i < itemsArray1.length; i++) {
        data.updates[itemsArray1[i]] = qty;
      }
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function() { 
         rebuildCartHTML('mobile');
          $("span.number-wrapper").hide();
        }
      });
   // },1500);

  });

//});